import { Component, input } from '@angular/core';

/**
 * This component is the custom spinner component.
 */
@Component({
    selector: 'app-shared-components-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    standalone: true,
    imports: []
})
export class SpinnerComponent {
  // The input data that will show/hide the SpinnerComponent.
  readonly preload = input(false);

  // Determine whether the loader should display on full page or inside container.
  readonly fullPage = input(true);
}
